export const allowedParamsName = [
    "orderId",
    "assetReferenceType",
    "countryCode",
    "patientIdentifier",
    "patientId",
    "rxId",
    "revision",
    "revisionTags",
    "tags",
    "localId",
    "includePresignedLinks",
];
export const defaultCreateAssetParams = {
    initiatorCountryCode: "string",
    patientAnonymization: true,
    orthoExportSettings: {
        exportType: 0,
        exportFile: 0,
        fileType: 0
    },
    selectedCadCamSystemType: 0,
    assetType: 0,
    conversionType: 0,
    forceConversion: true,
    notifyRegions: [
        "string"
    ]
};
export class CustomError extends Error {
    constructor(message, status, errorDes = "") {
        super(message);
        Object.defineProperty(this, "statusCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "errorDescription", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.statusCode = status;
        this.errorDescription = errorDes;
    }
}
export const MAX_HTTP_CALL_RETRY = 3;
//# sourceMappingURL=utils.js.map